import React from 'react'
import './rarity.css'
import RARITYCHART1 from '../../assets/3.1 - GX Info.png'
import RARITYCHART2 from '../../assets/gxBudz_all.png'

const data = [
  {
    id: 1,
    image: RARITYCHART1,
    title: 'GX Infographic',
   },
  {
    id: 2,
    image: RARITYCHART2,
    title: 'GX',
  },
]

const Rarity = () => {
  return (
    <section id='rarity'>
      <h5>Discovering</h5>
      <h2>GX Rarity</h2>
      <p><center>Below you can find the GX Infographic showcasing data on GX. Also, view all 96 on one image!</center></p>
      
      <div className="container rarity__container">
        {
          data.map(({id, image, title}) => {
            return (
              <article key={id} className='rarity__item'>
              <div className="rarity__item-image">
                <img src={image} alt={title} />
              </div>
            </article>   
            )
          })
        }
      </div>
      </section>
  )
}

export default Rarity